import { createContext } from 'react'
import { AutoClaimContextInfo } from '../types'

export const AutoClaimContext = createContext<AutoClaimContextInfo>(null)
